const FormLabel = {
  baseStyle: {
    color: "darkBlue",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    mb: "4px",
  },
};

export default FormLabel;
